/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Alt_Col_BestInputs */

const en_pc_alt_col_best = /** @type {(inputs: Pc_Alt_Col_BestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Strongest at`)
};

const zh_pc_alt_col_best = /** @type {(inputs: Pc_Alt_Col_BestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最擅长`)
};

/**
* | output |
* | --- |
* | "Strongest at" |
*
* @param {Pc_Alt_Col_BestInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_alt_col_best = /** @type {((inputs?: Pc_Alt_Col_BestInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Alt_Col_BestInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_alt_col_best(inputs)
	return zh_pc_alt_col_best(inputs)
});
export { pc_alt_col_best as "pc.alt.col.best" }